app.controller(
    'AdminListCityController', ['$scope', AdminListCityController]
);

function AdminListCityController($scope) {

    $scope.selectedItem = null;
    $scope.listCities = [
        {
            name : 'Nom ville',
            lang : 'FR',
            dateRestitution : '31/09/2017',
            publicationPrint : '10/10/2017',
            publicationApp : '15/10/2017',
            diffuseur : 'LVCG App - LVCG Print',
            active : 'Oui'
        },
        {
            name : 'Nom ville',
            lang : 'FR',
            dateRestitution : '31/09/2017',
            publicationPrint : '10/10/2017',
            publicationApp : '15/10/2017',
            diffuseur : 'LVCG App - LVCG Print',
            active : 'Oui'
        },
        {
            name : 'Nom ville',
            lang : 'FR',
            dateRestitution : '31/09/2017',
            publicationPrint : '10/10/2017',
            publicationApp : '15/10/2017',
            diffuseur : 'LVCG App - LVCG Print',
            active : 'Non'
        },
        {
            name : 'Nom ville',
            lang : 'FR',
            dateRestitution : '31/09/2017',
            publicationPrint : '10/10/2017',
            publicationApp : '15/10/2017',
            diffuseur : 'LVCG App - LVCG Print',
            active : 'Oui'
        },
        {
            name : 'Nom ville',
            lang : 'FR',
            dateRestitution : '31/09/2017',
            publicationPrint : '10/10/2017',
            publicationApp : '15/10/2017',
            diffuseur : 'LVCG App - LVCG Print',
            active : 'Non'
        },
        {
            name : 'Nom ville',
            lang : 'FR',
            dateRestitution : '31/09/2017',
            publicationPrint : '10/10/2017',
            publicationApp : '15/10/2017',
            diffuseur : 'LVCG App - LVCG Print',
            active : 'Non'
        },
        {
            name : 'Nom ville',
            lang : 'FR',
            dateRestitution : '31/09/2017',
            publicationPrint : '10/10/2017',
            publicationApp : '15/10/2017',
            diffuseur : 'LVCG App - LVCG Print',
            active : 'Non'
        }
    ];

    $scope.showOptions = function(item, $event)
    {
        $event.stopPropagation();
        $scope.selectedItem = $scope.selectedItem == item ? null : item;
    };

    $scope.close = function(){
        $scope.selectedItem = null;
    };
}